// extracted by mini-css-extract-plugin
export default {"wrap":"SH-z","articleImagesWrap":"TH-z","articleImage":"UH-z","singleImage":"VH-z"};